"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import type { FollowListKind } from "./api";
import FollowListDialog from "./FollowListDialog";
type Open = (kind: FollowListKind) => void;
const OpenPeople = createContext<Open | null>(null);

/** The profile's one people dialog, opened from either of its figures (the doors, or the glass on a phone). */
export function FollowPeople(t0) {
  const $ = _c(10);
  const {
    lang,
    username,
    children
  } = t0;
  const [kind, setKind] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = k => setKind(k);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  const t2 = kind !== null;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setKind(null);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = kind ?? "followers";
  let t5;
  if ($[2] !== lang || $[3] !== t2 || $[4] !== t4 || $[5] !== username) {
    t5 = <FollowListDialog open={t2} onClose={t3} lang={lang} username={username} kind={t4} onKind={setKind} />;
    $[2] = lang;
    $[3] = t2;
    $[4] = t4;
    $[5] = username;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <OpenPeople.Provider value={open}>{children}{t5}</OpenPeople.Provider>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/** A figure that opens its list: the button keeps whatever face the hero gives it. */
export function PeopleButton(t0) {
  const $ = _c(9);
  const {
    kind,
    className,
    label,
    style,
    children
  } = t0;
  const open = useContext(OpenPeople);
  const t1 = `${className} v2-focus`;
  let t2;
  if ($[0] !== kind || $[1] !== open) {
    t2 = () => open?.(kind);
    $[0] = kind;
    $[1] = open;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== label || $[5] !== style || $[6] !== t1 || $[7] !== t2) {
    t3 = <button type="button" className={t1} style={style} aria-haspopup="dialog" aria-label={label} onClick={t2}>{children}</button>;
    $[3] = children;
    $[4] = label;
    $[5] = style;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}